__turbopack_context__.v({
  "card": "auth-page-module__164gkG__card",
  "consentPanel": "auth-page-module__164gkG__consentPanel",
  "description": "auth-page-module__164gkG__description",
  "eyebrow": "auth-page-module__164gkG__eyebrow",
  "mainContent": "auth-page-module__164gkG__mainContent",
  "pageWrapper": "auth-page-module__164gkG__pageWrapper",
  "submitButton": "auth-page-module__164gkG__submitButton",
  "title": "auth-page-module__164gkG__title",
});
